import { useAppSelector, useAppDispatch } from '@/store/new-order';
import { switchToCardFormStep, switchToPlansStep } from '@/store/new-order/stepsSlice';

import { type Plan } from '@/utils/mapProductObject';
import { stripePromise, onExpressCheckoutConfirm } from '@/utils/stripe/newOrderSubmitAdapter';

import PaymentMethodsScreenAdapterBase from './PaymentMethodsScreenAdapterBase';

const PaymentMethodsScreenAdapter = () => {
  const { selectedPlanBlockData, isSubmitting } = useAppSelector((state) => ({
    selectedPlanBlockData: {
      // should always be a selected plan here, sowwy for assertion
      selectedPlan: state.plans.selectedPlan as Plan,
      couponDiscountPercentage: state.coupon.discountPercentage,
    },
    isSubmitting: state.isSubmitting,
  }));

  const dispatch = useAppDispatch();

  return (
    <PaymentMethodsScreenAdapterBase
      selectedPlanBlockData={selectedPlanBlockData}
      isSubmitting={isSubmitting}
      stripePromise={stripePromise}
      onExpressCheckoutConfirm={onExpressCheckoutConfirm}
      onBackButtonClick={() => dispatch(switchToPlansStep())}
      onCardFormButtonClick={() => dispatch(switchToCardFormStep())}
    />
  );
};

export default PaymentMethodsScreenAdapter;
